export default "assets/images/icons/email-1a7e5cae.svg";